import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "p-switch__container p-switch_default" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, null, -1 /* HOISTED */)
const _hoisted_4 = [
  _hoisted_3
]

import { computed } from 'vue';
interface Props {
	modelValue?: boolean;
	disabled?: boolean;
	firstLabel?: string;
	secondLabel?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'pSwitch',
  props: {
    modelValue: { type: Boolean },
    disabled: { type: Boolean },
    firstLabel: {},
    secondLabel: {}
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const classes = computed(() => ({
	'p-switch_disabled': props.disabled,
	'p-switch_active': props.modelValue,
}));

const emit = __emit;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["p-switch", classes.value])
  }, [
    (_ctx.firstLabel)
      ? (_openBlock(), _createElementBlock("p", {
          key: 0,
          class: "p-switch__label",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('update:modelValue', false)))
        }, _toDisplayString(_ctx.firstLabel), 1 /* TEXT */))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        class: "p-switch__button",
        disabled: _ctx.disabled,
        onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('update:modelValue', !_ctx.modelValue)))
      }, _hoisted_4, 8 /* PROPS */, _hoisted_2),
      _renderSlot(_ctx.$slots, "default")
    ]),
    (_ctx.secondLabel)
      ? (_openBlock(), _createElementBlock("p", {
          key: 1,
          class: "p-switch__label",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('update:modelValue', true)))
        }, _toDisplayString(_ctx.secondLabel), 1 /* TEXT */))
      : _createCommentVNode("v-if", true)
  ], 2 /* CLASS */))
}
}

})